import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/sitemap.scss';

initMainHeader();
